<template>
  <div class="help">
    <Header :title="$t('m.Help')"></Header>
    <pdf></pdf>
  </div>
</template>
<script>
  import Header from '../header/header'
  import pdf from '@/components/content/pdf/pdf'

  export default {
    data() {
      return {}
    },
    mounted() {
      //  this.$showPDF('../../../static/pdf/user_help.pdf')
    },
    components: {
      Header,
      pdf
    }
  }
</script>
<style>
  .help {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/content/help.vue